import moment from 'moment';

import store from 'store';

import { changeLoadingRequest, changeLoadingResponse } from 'actions/common/loader';

import Auth from 'utils/auth';

export const isHandlerEnabled = (config = {}) => {
    // console.log('isHandlerEnabled - config', config);
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? false : true;
};

export const isAuthorization = (config = {}) => {
    // console.log('isHandlerEnabled - config', config);
    return config.hasOwnProperty('isAuthorization') && config.isAuthorization === false ? true : false;
};

export const requestHandler = (request) => {
    // console.log('requestHandler - request', request);
    // console.log('requestHandler - isHandlerEnabled', isHandlerEnabled(request));
    store.dispatch(changeLoadingRequest());

    if (isHandlerEnabled(request)) {
        // Modify request here
        // console.log('requestHandler - dispatch');
    }

    if (isAuthorization(request)) {
        delete request.headers.common.Authorization;
    }

    return request;
};

export const successHandler = (response) => {
    // console.log('successHandler - response', response);
    store.dispatch(changeLoadingResponse());
    if (isHandlerEnabled(response)) {
        // Hanlde Response
    }

    return response;
};

export const errorHandler = (error) => {
    // console.log('errorHandler - error', error);
    if (isHandlerEnabled(error.config)) {
        store.dispatch(changeLoadingResponse());
        // You can decide what you need to do to handle errors.
        // here's example for unautherized user to log them out .
        // error.response.status === 401 && Auth.signOut();
    }

    const manager = store.getState().manager;

    if (error.response.status === 401) {
        if (moment().unix() > manager.token.expires) {
            console.log('access token 만료로 로그아웃 처리');

            Auth.signOut();
        }
    }

    return Promise.reject({ ...error });
};
